// 用户是否有效
export const getCityKey = function (v) {
  return 'c-' + v
}

export const coachName = 'cocah'



// WEBPACK FOOTER //
// ./src/components/page-client/common.js